<div [class.rtl]="currLang == 'ar'" id="addGateModal" class="modal" tabindex="-1" role="dialog" style="direction: ltr;"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content" [ngStyle]="{'direction' : currLang == 'en' ? 'ltr' : 'rtl'}">
      <div class="modal-header">
        <h5 class="modal-title">{{state}} {{'gates.add-gate-modal.gate' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="addGateForm">
          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="outline" dir="ltr">
                <mat-label>{{'gates.add-gate-modal.gate-name' | translate}}</mat-label>
                <input matInput formControlName="name">
                <mat-error>{{getAddGateFormValidation('name')}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-6">
              <p-multiSelect #multiSelectGateGuards [options]="primeSelectSecurities"
              formControlName="guards_ids"
              defaultLabel="{{'gates.add-gate-modal.assign-to' | translate}}"
              emptyMessage="{{'gates.add-gate-modal.prime-select.no-security' | translate}}"
              emptyFilterMessage="{{'gates.add-gate-modal.prime-select.no-security-filter' | translate}}"
              (onChange)="primeSelectChanged($event , 'guards')">
              </p-multiSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p-multiSelect #multiSelectGateGrades [options]="primeSelectGrades"
              formControlName="grade_ids"
              defaultLabel="{{'gates.add-gate-modal.assigned-grades' | translate}}"
              emptyMessage="{{'gates.add-gate-modal.prime-select.no-grades' | translate}}"
              emptyFilterMessage="{{'gates.add-gate-modal.prime-select.no-grades-filter' | translate}}"
              (onChange)="primeSelectChanged($event , 'grades')">
              </p-multiSelect>
            </div>
            <div class="area col-5">
              <mat-form-field appearance="outline" dir="ltr">
                <mat-label>{{'gates.add-gate-modal.green-zone' | translate}}</mat-label>
                <input (keyup)="checkAreaValue()" (change)="zoneChanged($event)" matInput formControlName="area">
                <mat-error>{{getAddGateFormValidation('area')}}</mat-error>
                <span matTextSuffix class="zone-suffix">{{'gates.add-gate-modal.meter' | translate}}</span>
              </mat-form-field>
              <div [class]="infoClass ?  'info-container show': 'info-container hide'">
                <span>{{'gates.add-gate-modal.area-info' | translate}}</span>
              </div>
              <svg (click)="openInfo()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                [ngStyle]="{'left': currLang == 'en' ? '1rem' : '-1rem'}">
                <g id="Group_5174" data-name="Group 5174" transform="translate(-1172 -224)">
                  <g id="Ellipse_652" data-name="Ellipse 652" transform="translate(1172 224)" fill="none"
                    stroke="#b7b7b7" stroke-width="1">
                    <circle cx="12" cy="12" r="12" stroke="none" />
                    <circle cx="12" cy="12" r="11.5" fill="none" />
                  </g>
                  <path id="Path_5462" data-name="Path 5462"
                    d="M3.669-5.9V1.486A5.173,5.173,0,0,0,3.743,2.5a.937.937,0,0,0,.247.509.714.714,0,0,0,.434.18q.262.022.636.022v.359H.6V3.208a3.258,3.258,0,0,0,.741-.067.737.737,0,0,0,.427-.262,1.049,1.049,0,0,0,.187-.532,8.068,8.068,0,0,0,.037-.861V-2.048q0-.868-.03-1.378a3.532,3.532,0,0,0-.1-.756A.474.474,0,0,0,1.64-4.5a.86.86,0,0,0-.367-.067,1.323,1.323,0,0,0-.307.037A3.578,3.578,0,0,0,.6-4.414l-.15-.359L3.219-5.9ZM2.83-10.7a.986.986,0,0,1,.726.292.986.986,0,0,1,.292.726.993.993,0,0,1-.292.719.973.973,0,0,1-.726.3.973.973,0,0,1-.726-.3.993.993,0,0,1-.292-.719.986.986,0,0,1,.292-.726A.986.986,0,0,1,2.83-10.7Z"
                    transform="translate(1180.884 238.703)" fill="#b7b7b7" />
                </g>
              </svg>
            </div>
            <!-- <span class="meter"
              [ngStyle]="{'right': currLang == 'en' ? '6rem' : 'auto' , 'left': currLang == 'ar' ? '6rem' : 'auto' }">{{'gates.add-gate-modal.meter'
              | translate}}</span> -->
          </div>
          <div>
            <app-map [mapView]="'add-gate'" [mapControls]="mapControls" [showMarker]="true" [isMarkerDraggable]="false" [showAddressSection]="false" [showSearchBar]= "true" [showCircles]="true" [showCurrentLocationBtn]="true" [isModalClosed]="modalClosed" (eventHandle)="mapEventHandle($event)"></app-map>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button [disabled]="addGateForm.invalid" (click)="saveGate()" type="button"
          class="btn btn-primary save">{{'gates.add-gate-modal.save' | translate}}</button>
      </div>
    </div>
  </div>
</div>